import { cn } from '@/lib/utils';

interface AuthorBylineProps {
    name: string;
    /** Italic + color + margin classes applied to the whole byline wrapper. */
    className?: string;
}

/** Shared italic "By {name}" byline for journal cards + article pages. */
export function AuthorByline({ name, className }: AuthorBylineProps) {
    return <span className={cn('block text-[11px] italic', className)}>By {name}</span>;
}
